module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-One-modern-5c594752f045343f506ec75b5c94e181.pdf";